import { IntegrationType} from '@/api';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useStore } from '@nanostores/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { revokeTcnApiKey } from '@/stores/tcnStore';

interface RevokeApiKeyConfirmationProps {
  isOpen: boolean;
  handleOpen: (boolean: boolean) => void;
  integrationType: IntegrationType;
}

export const RevokeApiKeyConfirmation = ({
  isOpen,
  handleOpen,
  integrationType
}: RevokeApiKeyConfirmationProps) => {
  const queryClient = useQueryClient();
  const org = useStore($org);
  const revokeApiKeyMutation = useMutation({
    mutationFn: async (): Promise<any> => {
      if (!org) return;
      const res = await revokeTcnApiKey(org.id);
      return res;
    },
    onSuccess: async data => {
      toast('Successfully revoked TCN API key', {
        description: "success",
        duration: 5000,
      });
    },
    onError: error => {
      console.error(error);
      toast('An error occurred', {
        description: error.message,
        duration: 5000,
      });
    },
  });

  return (
    <AlertDialog open={isOpen} onOpenChange={handleOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={async e => {
              e.preventDefault();
              if (integrationType === 'TCN') {
                await revokeApiKeyMutation.mutateAsync();
                queryClient.invalidateQueries({ queryKey: ['getOrgIntegrations', org?.id] });
              }
              handleOpen(false);
            }}
            disabled={revokeApiKeyMutation.isPending}
            className="bg-red-600 hover:bg-red-500 dark:text-white dark:hover:bg-red-700"
          >
            {revokeApiKeyMutation.isPending ? 'Processing...' : 'Continue'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
